/** @file Maps a key code on an open menu to a focus move, a close, or nothing. */
import { stepIndex } from './stepIndex';

/** What the menu should do for a key. */
export type MenuKeyAction = { kind: 'move'; index: number } | { kind: 'close' } | { kind: 'none' };

const NONE: MenuKeyAction = { kind: 'none' };
const move = (index: number): MenuKeyAction => ({ kind: 'move', index });

/** Arrows wrap over enabled items, Home/End jump, Escape and Tab close; `active` is -1 when nothing is focused. */
export function menuKey(code: string, active: number, disabled: readonly boolean[]): MenuKeyAction {
  switch (code) {
    case 'ArrowDown': return move(stepIndex(active, 1, disabled, true));
    case 'ArrowUp': return move(stepIndex(active, -1, disabled, true));
    case 'Home': return move(stepIndex(-1, 1, disabled, false));
    case 'End': return move(stepIndex(-1, -1, disabled, false));
    case 'Escape':
    case 'Tab': return { kind: 'close' };
    default: return NONE;
  }
}
